import { render } from "./RecordAttributesManager.vue?vue&type=template&id=063d98c0&scoped=true"
import script from "./RecordAttributesManager.vue?vue&type=script&lang=js"
export * from "./RecordAttributesManager.vue?vue&type=script&lang=js"

import "./RecordAttributesManager.vue?vue&type=style&index=0&id=063d98c0&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063d98c0"]])

export default __exports__